
import React from 'react';

import {
    Grid,
    Typography,
    InputAdornment,
    ButtonBase,
    Snackbar,
    Divider,
    ChevronRightOutlinedIcon,
    withStyles,
    withRouter
} from '../../material-ui';

import DeviceEventEmitter, { EventName } from '../../control/event';
import ErrorCode from '../../network/errorcode';
import AppData from '../../model/AppData';
import MEditText from '../view/MEditText';
import MArrowBack from '../view/MArrowBack';
import MButton from '../view/MButton';
import AppUtils from '../../control/apputlis';

const SEND_VERIFY_CODE = '获取验证码';

class RegisterPage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            areaCode: 86,
            phonenum: '',
            phone_valid: false,
            code_valid: false,
            invitecode: AppData.InviteCode ? AppData.InviteCode : '',
            login_failed: false,
            code: '',
            verifyCodeLeftTime: 0,
            isVerifyCodeRequesting: false,
            verifyCodeBtnTitle: SEND_VERIFY_CODE,
            snackopened: false,
            message: '',
            nick: ''
        };

        this._onAreaCodeSelected = this._onAreaCodeSelected.bind(this);
        this._submitLoginCredentials = this._submitLoginCredentials.bind(this);
        this._onRegisterSuccess = this._onRegisterSuccess.bind(this);
        this._onRegisterFailed = this._onRegisterFailed.bind(this);
        this._onVerifyCodeClick = this._onVerifyCodeClick.bind(this);
        this._verifyCodeTimeAction = this._verifyCodeTimeAction.bind(this);
    }

    validatePhone(phone) {
        var re = /^1[3-9]\d{9}$/;
        return re.test(phone);
    }

    validateCode(code) {
        var re = /^[0-9]+.?[0-9]*/;
        return re.test(code) && (code.length >= 4 && code.length <= 6);
    }

    _submitLoginCredentials() {
        const { phonenum, invitecode, code, showLoading } = this.state;
        if (!showLoading) {
            if (!this.validatePhone(phonenum)) {
                this.setState({ message: '请正确填写手机号码', snackopened: true });
                return;
            }
            if (!code || code === '') {
                this.setState({ message: '验证码不能为空', snackopened: true });
                return;
            }

        }
    }

    _onVerifyCodeClick() {
        if (this.state.isVerifyCodeRequesting || this.state.verifyCodeLeftTime > 0) {
            return;
        }
        const phonenum = this.state.phonenum;
        if (!this.validatePhone(phonenum)) {
            this.setState({ message: '请正确填写手机号码', snackopened: true });
            return;
        }
        this.setState({
            isVerifyCodeRequesting: true,
            verifyCodeBtnTitle: '',
        });
        this._verifyCodeTimeAction();
    }

    _verifyCodeTimeAction() {
        let codeTime = 60;
        this.setState({
            verifyCodeLeftTime: codeTime,
            isVerifyCodeRequesting: true,
            verifyCodeBtnTitle: codeTime + 's',
        });
        this.interval = setInterval(() => {
            codeTime--;
            this.setState({
                verifyCodeLeftTime: codeTime,
                verifyCodeBtnTitle: `${codeTime}s`,
            });
            if (codeTime <= 0) {
                this.interval && clearInterval(this.interval);
                this.setState({
                    verifyCodeLeftTime: 0,
                    verifyCodeBtnTitle: SEND_VERIFY_CODE,
                    isVerifyCodeRequesting: false,
                });
            }
        }, 1000);
    }

    componentDidMount() {
        DeviceEventEmitter.on(EventName.USER_REGISTER_SUCCESS, this._onRegisterSuccess, this);
        DeviceEventEmitter.on(EventName.USER_REGISTER_FAILED, this._onRegisterFailed, this);
        AppUtils.YMPush('MAIN', 'RegisterPage');
    }

    componentWillUnmount() {
        DeviceEventEmitter.off(EventName.USER_REGISTER_SUCCESS, this._onRegisterSuccess, this);
        DeviceEventEmitter.off(EventName.USER_REGISTER_FAILED, this._onRegisterFailed, this);
        this.interval && clearInterval(this.interval);
    }

    _onRegisterSuccess(e) {
        AppUtils.YMPush('MAIN', '注册成功');
        console.log("_onRegisterSuccess", e);
        if (this.props.location.state == 1) {
            //返回上一页
            window.history.back();
        } else {
            this.props.history.push("/");
        }
    }

    _onRegisterFailed(e) {
        let errMsg = '';
        switch (e) {
            case ErrorCode.CODE_VERIFY_CODE_ERROR:
                errMsg = '验证码错误';
                break;
            case ErrorCode.CODE_PWD_LEN_ERROR:
                errMsg = '密码长度不符';
                break;
            case ErrorCode.CODE_MULTI_REGISTER:
                errMsg = '该号码已经注册';
                break;
            default:
                errMsg = '注册失败:' + e;
                break;
        }
        this.setState({ message: errMsg, snackopened: true });
    }

    _onAreaCodeSelected(event) {
        this.setState({
            areaCode: event.target.value,
        })
    }

    render() {
        const { classes } = this.props;
        const { phonenum, nick, invitecode, code, verifyCodeBtnTitle, phone_valid, code_valid, snackopened, message } = this.state;
        return (
            <React.Fragment>
                <div className={classes.root}>
                    <MArrowBack />
                    <div style={{ height: 30 }}></div>
                    <Grid className={classes.titleGrid}>
                        <Typography className={classes.titleText}>手机号注册</Typography>
                        <div style={{ height: 43 }}></div>
                        <MEditText
                            className={classes.textfield}
                            placeholder="例如内马尔"
                            type='text'
                            value={nick}
                            onChange={event => this.setState({ nick: event.target.value, phone_valid: this.validatePhone(event.target.value) })}
                            startLabel='昵称'
                            maxLength={11}
                        />
                        <Grid container direction='column'>
                            <Grid container alignItems='center' direction='row' justifyContent='space-between'>
                                <Typography style={{ fontSize: 16, color: '#0D0D0D' }}>国家/地区 中国大陆</Typography>
                                <ChevronRightOutlinedIcon style={{ color: '#0D0D0D', fontSize: 20 }} />
                            </Grid>
                            <Divider className={classes.diviver} />
                        </Grid>
                        <MEditText
                            className={classes.textfield}
                            placeholder="输入手机号"
                            type='tel'
                            value={phonenum}
                            onChange={event => this.setState({ phonenum: event.target.value, phone_valid: this.validatePhone(event.target.value) })}
                            startLabel='+86'
                            maxLength={11}
                        />
                        <MEditText
                            className={classes.textfield}
                            placeholder="数字验证码"
                            type={'tel'}
                            value={code}
                            startLabel='验证码'
                            onChange={event => this.setState({ code: event.target.value, code_valid: this.validateCode(event.target.value) })}
                            maxLength={6}
                            endAdornment={
                                <InputAdornment position="end" style={{ border: 'solid 1px #E2E2E2', width: 78, height: 25, borderRadius: 12.5 }}>
                                    <ButtonBase
                                        disableRipple
                                        style={{ fontSize: 11, fontWeight: 600, width: 78, color: '#0D0D0D' }}
                                        onClick={this._onVerifyCodeClick}>
                                        {verifyCodeBtnTitle}
                                    </ButtonBase>
                                </InputAdornment>
                            }
                        />
                        <Grid container justifyContent='center' >
                            <MButton disabled={!(phone_valid && code_valid)} onClick={this._submitLoginCredentials}>确定并登录</MButton>
                        </Grid>
                    </Grid>
                    <Snackbar
                        anchorOrigin={{
                            vertical: 'top',
                            horizontal: 'center',
                        }}
                        open={snackopened}
                        onClose={() => this.setState({ snackopened: false })}
                        message={message}
                        autoHideDuration={3000}>
                    </Snackbar>
                </div>
            </React.Fragment >

        );
    }
}

export default withRouter(withStyles((theme) => (
    {
        root: {
            width: '100vw',
            height: '100vh',
            display: "flex",
            flexDirection: "column",
            alignItems: 'center',
            backgroundColor: theme.palette.background.default,
        },
        appbar: {
            top: 0,
            height: 48,
            backgroundColor: 'transparent',
            boxShadow: 'none'
        },
        titleGrid: {
            padding: theme.spacing(7, 2, 5, 2),
            color: 'black',
        },
        titleText: {
            fontSize: 25,
            padding: theme.spacing(0, 0, 0, 0),
        },
        paperTop: {
            paddingTop: 45,
            backgroundColor: theme.palette.background.default,
        },
        textfield: {
            margin: theme.spacing(2, 0, 1, 0),
            color: '#0D0D0D',
            fontSize: 13,
            height: 30,
            alignItems: 'center',
            justifyContent: 'center',
        },
        titleLabel: {
            margin: theme.spacing(0, 1, 0, 1),
            fontSize: 13,
            width: 60,
            fontWeight: theme.typography.fontWeightBold,
        },
        loginBtn: {
            background: '#007AFF',
            borderRadius: 22.5,
            color: 'white',
            height: 45,
            width: "calc(100vw - 32px)",
            margin: theme.spacing(5, 0, 2, 0),
            fontSize: 14,
            fontWeight: theme.typography.fontWeightBold,
        },
        backBtn: {
            color: theme.palette.common.default,
            fontSize: 13,
        },
        textfield1: {
            borderBottomColor: '#E2E2E2',
            border: 0,
            outline: 'none',
        },
        diviver: {
            color: '#E2E2E2',
            height: 1,
            width: '100%',
            marginTop: 8,
            marginBottom: 8,
        }
    }
))(RegisterPage));